import React from 'react';

export interface StringStringOption
{
  value: string,
  label: string
}

interface ButtonSelectProps<TOption> {
  options: Array<TOption>;
  option: TOption | undefined;
  getOptionText: (option: TOption) => string;
  getOptionKey: (option: TOption) => string;
  onOptionSelected: (option: TOption) => void;
  wOverride?: string
}

function ButtonSelect<TOption>(
  props: React.PropsWithChildren<ButtonSelectProps<TOption>>
) {

  const className = props.wOverride 
    ? `${props.wOverride}`
    :'w-1/2 md:w-1/3 p-2 inline-block';

  return (
    <div>
      {props.options.map((option) => (
        <div 
          key={props.getOptionKey(option)}
          className={className}>
        <button
          className="btn-choice"
          
          onClick={() => props.onOptionSelected(option)}
        >
          {props.getOptionText(option)}
        </button>
        </div>
      ))}
    </div>
  );
}

export default ButtonSelect;
